{
  "page": {
    "title": "Justificaciones",
    "subtitle": "Tardanzas, salidas anticipadas y faltas que los trabajadores explican. Aprobar no borra los minutos: el tareo los conserva con la marca de justificada.",
    "noResults": "Ninguna justificación coincide con los filtros aplicados."
  },
  "tab": {
    "label": "Justificaciones"
  },
  "filters": {
    "legend": "Filtrar justificaciones",
    "status": "Estado",
    "statusAll": "Todas",
    "site": "Sede",
    "allSites": "Todas las sedes",
    "worker": "Trabajador",
    "allWorkers": "Todos los trabajadores",
    "workerPlaceholder": "Buscar trabajador",
    "kind": "Tipo",
    "allKinds": "Todos los tipos",
    "fromDay": "Desde",
    "toDay": "Hasta"
  },
  "statusFilter": {
    "PENDING": "Pendientes",
    "APPROVED": "Aprobadas",
    "REJECTED": "Rechazadas",
    "CANCELLED": "Canceladas"
  },
  "empty": {
    "title": "No hay justificaciones pendientes",
    "description": "Cuando un trabajador justifique una tardanza, una salida anticipada o una falta, aparecerá aquí."
  },
  "error": {
    "title": "No pudimos cargar las justificaciones",
    "notFound": "Esta justificación no existe o está fuera de tu alcance."
  },
  "table": {
    "caption": "Justificaciones de tardanzas, salidas anticipadas y faltas",
    "worker": "Trabajador",
    "site": "Sede",
    "day": "Día",
    "kind": "Tipo",
    "reason": "Motivo",
    "age": "Hace",
    "status": "Estado",
    "actions": "Acciones",
    "review": "Revisar",
    "view": "Ver",
    "close": "Cerrar"
  },
  "kinds": {
    "LATE": "Tardanza",
    "EARLY_LEAVE": "Salida anticipada",
    "ABSENCE": "Falta"
  },
  "kindsWithMinutes": {
    "LATE": "Tardanza · {minutes} min",
    "EARLY_LEAVE": "Salida anticipada · {minutes} min"
  },
  "status": {
    "PENDING": "Pendiente",
    "APPROVED": "Aprobada",
    "REJECTED": "Rechazada",
    "CANCELLED": "Cancelada"
  },
  "noLongerApplies": "Ya no aplica",
  "noLongerAppliesHint": "El día ya no tiene este hecho (por ejemplo, se corrigió una marca). Ciérrala para sacarla de la bandeja.",
  "review": {
    "title": "Revisar justificación",
    "viewTitle": "Justificación",
    "description": "{worker} · {site}",
    "dayTitle": "Resumen del día",
    "day": "Día",
    "shifts": "Turno",
    "noShift": "Sin turno asignado",
    "shift": "{name} {start} – {end}",
    "evaluation": "Evaluación actual",
    "workedMinutes": "Trabajó {hours}",
    "justified": "Justificada",
    "workerReason": "Motivo del trabajador",
    "adminReason": "Motivo registrado",
    "origin": {
      "WORKER": "La envió el trabajador",
      "ADMIN": "La registró un administrador"
    },
    "note": "Nota para el trabajador (opcional)",
    "noteHelp": "El trabajador verá esta nota junto a la aprobación.",
    "willKeep": "Aprobar no borra los minutos: el día queda como justificado y el tareo los conserva.",
    "approve": "Aprobar",
    "reject": "Rechazar",
    "close": "Cerrar solicitud",
    "approvedToast": "Justificación aprobada",
    "rejectedToast": "Justificación rechazada",
    "closedToast": "Justificación cerrada",
    "resolvedBy": "{action} por {name} el {at}",
    "resolvedBySomeone": "{action} el {at}",
    "resolution": {
      "APPROVED": "Aprobada",
      "REJECTED": "Rechazada"
    },
    "resolutionNote": "Nota: {note}",
    "rejectionReason": "Motivo del rechazo: {reason}",
    "cancelled": "Cancelada el {at}",
    "history": "Historial",
    "historyActor": {
      "WORKER": "El trabajador"
    },
    "historyAction": {
      "JUSTIFICATION_REQUESTED": "Envió la justificación",
      "JUSTIFICATION_REGISTERED": "Registró la justificación",
      "JUSTIFICATION_APPROVED": "Aprobó",
      "JUSTIFICATION_REJECTED": "Rechazó",
      "JUSTIFICATION_CANCELLED": "Canceló"
    }
  },
  "cancelReasons": {
    "WORKER": "El trabajador la canceló.",
    "NO_LONGER_APPLIES": "Se cerró porque el día ya no tenía el hecho.",
    "WORKER_DEACTIVATED": "Se canceló al desactivar al trabajador."
  },
  "reject": {
    "title": "Rechazar justificación",
    "description": "El trabajador verá este motivo. Sé claro y respetuoso.",
    "reason": "Motivo del rechazo",
    "reasonRequired": "Escribe el motivo del rechazo.",
    "confirm": "Rechazar"
  },
  "register": {
    "open": "Registrar justificación",
    "title": "Registrar justificación",
    "description": "{worker} · {day}. Quedará aprobada a tu nombre.",
    "kind": "Qué se justifica",
    "reason": "Motivo",
    "reasonHelp": "Por ejemplo, la constancia que entregó a RRHH.",
    "reasonRequired": "Escribe el motivo.",
    "note": "Nota (opcional)",
    "confirm": "Registrar",
    "registeredToast": "Justificación registrada"
  },
  "errors": {
    "unavailable": {
      "NOTHING_TO_JUSTIFY": "Ese día ya no tiene nada que justificar.",
      "DAY_NOT_FINAL": "El turno de ese día todavía no termina.",
      "OUTSIDE_WINDOW": "Ese día está fuera del plazo para justificar.",
      "ALREADY_OPEN": "Ya hay una justificación en revisión para ese día.",
      "LIMIT_REACHED": "Ya se alcanzó el máximo de justificaciones para ese día.",
      "WORKER_NOT_ACTIVE": "El trabajador no está activo.",
      "STILL_APPLIES": "Esta justificación todavía aplica: apruébala o recházala."
    },
    "notOpen": "Esta justificación ya no está pendiente: otra persona la resolvió.",
    "periodClosed": "El período de ese día está cerrado."
  }
}
